import { render, staticRenderFns } from "./digitalNewspaperLayout.vue?vue&type=template&id=230f7f9e&scoped=true&"
import script from "./digitalNewspaperLayout.vue?vue&type=script&lang=js&"
export * from "./digitalNewspaperLayout.vue?vue&type=script&lang=js&"
import style0 from "./digitalNewspaperLayout.vue?vue&type=style&index=0&id=230f7f9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f7f9e",
  null
  
)

export default component.exports